<div style="text-align: center !important; ">
    <span *ngIf="routeSurveyId =='-99'"  >
        <p class="survey-resp">Thank you for taking the survey!</p>
    </span>
    <span *ngIf="expiredSurvey">
      <p class="survey-resp" >This survey is no longer available!</p>
  </span>
    <span *ngIf="alreadyTaken">
        <p class="survey-resp" >You have already taken this survey!</p>
    </span>
    <span *ngIf="isLoginRequired == true">
        <p class="survey-resp" > Please login to Health Slice portal to take this survey!</p>
    </span>

</div>

